import { GetStaticProps } from 'next';
import { Heading, HeadingType } from '../../../components';
import {
  BREADCRUMB_TYPE,
  Breadcrumb,
} from '../../../components/Atoms/BreadCrumb';
import { CalculatorCard } from '../../../components/Calculators/calculator-revamp/components/CalculatorCard';
import { CALCULATOR_DATA } from '../../../components/Calculators/calculator-revamp/components/CalculatorCard/constants';
import {
  getCalculatorPageUrl,
  getImageForCalculator,
} from '../../../components/Calculators/calculator-revamp/utils';
import { ClearInNavbar } from '../../../components/Navbar/ClearNavbar';
import { ISINGLE_POST } from '../../../components/cms/layout/types';
import {
  ORG_SCHEMA,
  getBreadCrumbSchema,
} from '../../../constants/componentStaticData';
import { Meta } from '../../../layout/Meta';
import { returnNoProps } from '../../../utils/UtilFunctions';
import { staticPropsWrapper } from '../../../utils/static-pages/utils';

const Calculator = () => {
  const BREADCRUMB: Array<BREADCRUMB_TYPE> = [
    { title: 'Home', link: '/' },
    { title: 'Calculators', link: null },
  ];

  return (
    <div>
      <ClearInNavbar />
      <Meta
        title="Financial Calculators - Calculate And Plan Your Investments Online With ClearTax"
        description="Financial Calculators - Plan all your finance & investments by using Cleartax Financial Calculators for different investment options which satisfies all your needs. Make your Finances easy and sorted by choosing best investment options to achieve the financial goals."
        canonical="https://cleartax.in/calulators"
        favicon="https://assets1.cleartax-cdn.com/cleartax/images/1644906212_clearfavicon.png"
      ></Meta>

      <div className="wg-container mb-12">
        <Breadcrumb dataSet={BREADCRUMB} className="pt-6 sm:pt-3" />

        <Heading
          variant={HeadingType.h2}
          content="Calculators"
          className="my-12 sm:my-8"
        />

        <div className="grid grid-cols-3 gap-10 sm:grid-cols-2 sm:gap-2">
          {CALCULATOR_DATA?.map((item: ISINGLE_POST) => (
            <div className="w-full" key={item.title}>
              <CalculatorCard
                title={item.title}
                desc={item.description}
                image={getImageForCalculator(item.permalink)}
                link={getCalculatorPageUrl(item).CURR_PAGE_URL}
              />
            </div>
          ))}
        </div>
      </div>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(getBreadCrumbSchema(BREADCRUMB)),
        }}
      ></script>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(ORG_SCHEMA) }}
      ></script>
    </div>
  );
};

export const getStaticProps: GetStaticProps = staticPropsWrapper(
  __filename,
  () => {
    return returnNoProps();
  }
);

export default Calculator;
